import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostListener,
    signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormSelectDirective } from '@coreui/angular';
import { IconDirective } from '@coreui/icons-angular';

import { environment } from '../../../environments/environment';
import { SettingsService } from '../../services/settings/settings.service';
import { Theme, ThemeService } from '../../services/theme/theme.service';

@Component({
    selector: 'app-debug-fab',
    standalone: true,
    imports: [FormsModule, FormSelectDirective, IconDirective],
    templateUrl: './debug-fab.component.html',
    styleUrl: './debug-fab.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DebugFabComponent {
    readonly open = signal(false);
    readonly apiUrlOptions = environment.apiUrl;
    readonly themeOptions: { value: Theme; label: string }[] = [
        { value: 'light', label: 'Light' },
        { value: 'dark', label: 'Dark' },
        { value: 'auto', label: 'Auto' },
    ];

    get apiUrl(): string {
        return this.settingsService.apiUrl;
    }

    get theme(): Theme {
        return this.themeService.theme();
    }

    constructor(
        private settingsService: SettingsService,
        private themeService: ThemeService,
        private elementRef: ElementRef,
    ) {}

    toggle(): void {
        this.open.update((v) => !v);
    }

    setApiUrl(value: string): void {
        this.settingsService.apiUrl = value;
    }

    setTheme(value: Theme): void {
        this.themeService.setTheme(value);
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        if (this.open() && !this.elementRef.nativeElement.contains(event.target)) {
            this.open.set(false);
        }
    }
}
